<div *ngIf="!item?.local_only">
  <p-tabs (changeTab)="changeTab($event)" [value]="active">
    <p-tablist>
      <p-tab *ngIf="course" value="Course">
        {{'course'|translation}}
      </p-tab>
      <p-tab *ngIf="source!='text'" value="Global">
        {{'global'|translation}}
      </p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel *ngIf="course" value="Course">
        <app-filebrowser [scope]="course" [allowupload]="true" (selectFile)="passSelectedFile($event)" [allowSelection]="allowSelection" [filter]="filter" [readOnly]="item.read_only"></app-filebrowser>
      </p-tabpanel>
      <p-tabpanel *ngIf="source!='text'" value="Global">
        <app-filebrowser [scope]="'institution'" [allowupload]="!course" (selectFile)="passSelectedFile($event)" [allowSelection]="allowSelection" [filter]="filter"></app-filebrowser>
        </p-tabpanel>
    </p-tabpanels>
  </p-tabs>

  <app-filebrowser *ngIf="source=='text'" [scope]="'institution'"
  [readOnly]="true"
  [allowupload]="false" (selectFile)="passSelectedFile($event)" [allowSelection]="allowSelection" [filter]="filter"></app-filebrowser>

</div>
<div *ngIf="item?.local_only">
      <app-filebrowser [scope]="course" [allowupload]="true" (selectFile)="passSelectedFile($event)" [allowSelection]="allowSelection" [filter]="filter" [readOnly]="item.read_only"></app-filebrowser>  
</div>
